import React from 'react';
import { Page } from '../components';

const NotFound = () => (
  <Page category="Monaco" title="404 - Not Found">
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <h2>Sorry, the page you are looking for could not be found.</h2>
    </div>
  </Page>
);

export default NotFound;
